import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addJob } from "../../../store/actions/Jobs/jobActions";
import { get } from "../../../services/api";
import { days } from "../../constant/weekday";
import { debounce } from "../../../utils/debounce";

const AddRequirementJob = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    regDate: new Date(),
    companyId: "",
    company: "",
    jobTitle: "",
    jobID: "",
    latestActionDate: new Date(),
    jobStartDate: null,
    jobEndDate: null,
    service: "BOOKING",
    salary: 0,
    status: "LIVE",
    payIn: "",
    feePercentage: "",
    reason: "Standard Requirement",
    accountNumber: "",
    orderNumber: "",
    controllerId: props.loggedInUser?._id,
    controller: `${props.loggedInUser?.firstName} ${props.loggedInUser?.lastName}`,
    currency: "sterling",
    candidates: 0,
    postCode: "",
    payRates: [],
    daysOfWork: [],
    location: "",
    jobType: "",
    jobContact: "",
    jobReportTo: "",
    jobInvoiceTo: "",
    statusDate: new Date(),
    quantity: 1,
    hoursOfWork: "",
    duties: "",
    healthSafety: "",
    experience: "",
    notes: "",
  });

  const [postCodeResults, setPostCodeResults] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [jobTypeListValues, setJobTypeListValues] = useState([]);
  const [payRateType, setPayRateType] = useState([]);

  const [invoiceTo, setInvoiceTo] = useState([]);
  const [reportTo, setReportTo] = useState([]);
  const [contactList, setContactList] = useState([]);

  const fetchCompanies = async () => {
    try {
      const res = await get("/api/company", props.token);
      setCompanies(res);
      generateCompanyOptions(res);
    } catch (error) {
      console.error("Error fetching companies:", error);
      toast.error("Failed to fetch companies");
    }
  };

  const generateCompanyOptions = (companiesData) => {
    if (!companiesData || !Array.isArray(companiesData) || companiesData.length === 0) {
      return [];
    }
    const options = [];
    
    companiesData.forEach((company, index) => {
      const groupId = `company-group-${index}`;
      
      const parentOption = {
        value: company._id,
        label: company.companyName,
        isParent: true,
        groupId: groupId
      };
      
      options.push(parentOption);
      
      if (company.childCompanies && company.childCompanies.length > 0) {
        company.childCompanies.forEach(child => {
          options.push({
            value: child._id,
            label: `${company.companyName} - ${child.companyName}`,
            isChild: true,
            parentId: company._id,
            groupId: groupId
          });
        });
      }
    });
    
    setCompanyOptions(options);
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    const {
      town_or_city: locality = "",
      postcode: postCode = "",
    } = result; 
    
 
    setFormData((prevFormData) => ({
      ...prevFormData,
      location: locality,
      postCode,
    }));
    setPostCodeResults([]);
  };

  const getCompanyPeople = async (id) => {
    const res = await get("/api/company-contacts/company/" + id, props.token);


    if (res && res.length > 0) {
      const filteredInvoiceTo = res.filter(contactPerson => contactPerson.position === 'Invoice To').map((item)=>({value: item?._id, label: (item.firstName + " " + item.lastName)}));
      const filteredReportTo= res.filter(contactPerson => contactPerson.position === 'Report To').map((item)=>({value: item?._id, label: (item.firstName + " " + item.lastName)}));
      const filteredContact = res.filter(contactPerson => contactPerson.position === 'Contact').map((item)=>({value: item?._id, label: (item.firstName + " " + item.lastName)}));


      setInvoiceTo(filteredInvoiceTo);
      setReportTo(filteredReportTo);
      setContactList(filteredContact);
    }

  };
  useEffect(() => {
    console.log("props?.jobTypeList", props?.jobTypeList);
    if (!formData?.jobID) {
      fetchJobId();
    }



    if(props?.jobTypeList) {
      setJobTypeListValues(props?.jobTypeList?.map((itm)=>itm.value));
    }
    if(props?.payRateTypes) {
      setPayRateType(props?.payRateTypes?.map((itm)=>itm.value));
    }
  }, [props?.jobTypeList, props?.payRateTypes]);

  const fetchJobId = async () => {
    const jobId = await get("/api/sequence/job-id", props.token);
    setFormData((prevFormData) => ({
      ...prevFormData,
      jobID: jobId.value,
    }));
  };
  const resetForm = () => {
    setFormData({
      regDate: new Date(),
      companyId: "",
      company: "",
      jobTitle: "",
      jobID: "",
      latestActionDate: new Date(),
      jobStartDate: null,
      jobEndDate: null,
      service: "BOOKING",
      salary: 0,
      status: "LIVE",
      payIn: "",
      feePercentage: "",
      reason: "Standard Requirement",
      accountNumber: "",
      orderNumber: "",
      controllerId: props.loggedInUser?._id,
      controller: `${props.loggedInUser?.firstName} ${props.loggedInUser?.lastName}`,
      currency: "sterling",
      candidates: 0,
      postCode: "",
      payRates: [],
      daysOfWork: [],
      location: "",
      jobType: "",
      statusDate: new Date(),
      quantity: 1,
      hoursOfWork: "",
      duties: "",
      healthSafety: "",
      experience: "",
      notes: "",
    });
    setPayRates([]);
    setErrors({});
  };

  const [errors, setErrors] = useState({});
  const [addJobModal, setAddJob] = useState(false);
  const [payRates, setPayRates] = useState([]);

  useImperativeHandle(ref, () => ({
    showAddJobModal() {
      if (!formData?.jobID) {
        fetchJobId();
      }
      setAddJob(true);
    },
  }));

  const validate = () => {
    const newErrors = {};
    // Check nested contact fields
    if (!formData.jobTitle?.trim())
      newErrors.jobTitle = "Please enter job title.";
    if (!formData.jobStartDate)
      newErrors.jobStartDate = "Please enter job start date.";
    if (!formData.jobEndDate)
      newErrors.jobEndDate = "Please enter job end date.";
    if(!formData.company) 
      newErrors.company = "Please choose company name."
    if(!formData.location) 
      newErrors.location = "Please enter location."
  
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all required fields.");
    }

    return Object.keys(newErrors).length === 0;
  };
  // Handle input changes
  const [query, setQuery] = useState("");
  const fetchData = async (searchTerm) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${searchTerm}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setPostCodeResults(result.suggestions);
  };
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery);
    debounce(fetchData(inputQuery));
  };
  const handleInputChange = (field, value) => {
    if (field === "postCode") {
      handlePostCodeQueryChange(value);
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleDaySelection = (day) => {
    setFormData((prev) => {
      const daysOfWork = prev.daysOfWork.includes(day)
        ? prev.daysOfWork.filter((d) => d !== day)
        : [...prev.daysOfWork, day];
      return { ...prev, daysOfWork };
    });
  };

  const handleAddRow = () => {
    setPayRates((prev) => [
      ...prev,
      { payRate: "", chargeRate: "", type: (payRateType[0] || ""), band: "", description: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    setPayRates((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRateChange = (index, field, value) => {
    setPayRates((prev) => {
      const updatedRates = [...prev];
      updatedRates[index][field] = value;
      return updatedRates;
    });
  };
  const findCompanyById = (id) => {
    let company = companies.find(company => company._id === id);
    
    if (!company) {
      for (const parent of companies) {
        if (parent.childCompanies && parent.childCompanies.length > 0) {
          const child = parent.childCompanies.find(child => child._id === id);
          if (child) {
            company = child;
            break;
          }
        }
      }
    }
    
    return company;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const emptyPayRates = payRates.filter(rate => rate.payRate === "" || rate.payRate === null);
    const emptyChargeRates = payRates.filter(rate => rate.chargeRate === "" || rate.chargeRate === null);
    
    if (emptyPayRates.length > 0) {
      toast.error("Pay Rate cannot be empty. Please enter values for all pay rates.");
      return;
    }
    
    if (emptyChargeRates.length > 0) {
      toast.error("Charge Rate cannot be empty. Please enter values for all charge rates.");
      return;
    }
    if (validate()) {
      dispatch(addJob({ ...formData, payRates }, setAddJob, props.token, true, resetForm));
    }
  };

  return (
    <Offcanvas
      show={addJobModal}
      onHide={() => setAddJob(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            resetForm();
            setAddJob(false);
          }}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Company Name */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Job ID <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                disabled
                value={formData.jobID}
                onChange={(e) => handleInputChange("jobID", e.target.value)}
              />
              {errors.jobID && (
                <small className="text-danger">{errors.jobID}</small>
              )}
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Job Title <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.jobTitle}
                onChange={(e) => handleInputChange("jobTitle", e.target.value)}
              />
              {errors.jobTitle && (
                <small className="text-danger">{errors.jobTitle}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Job Type <span className="text-danger">*</span>
              </label>

              <Select
                value={
                  formData.jobType
                    ? {
                        value: formData.jobType,
                        label: formData.jobType,
                      }
                    : null
                }
                options={jobTypeListValues.map((itm) => ({
                  value: itm,
                  label: itm,
                }))}
                onChange={(selectedOption) =>
                  handleInputChange(
                    "jobType",
                    selectedOption ? selectedOption.value : ""
                  )
                }
              />
              {errors.jobType && (
                <small className="text-danger">{errors.jobType}</small>
              )}
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">Postcode</label>
              <input
                type="text"
                className="form-control"
                value={formData.postCode}
                onChange={(e) => handleInputChange("postCode", e.target.value)}
              />
              {postCodeResults?.length > 0 && (
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    maxHeight: "150px", // Medium size scrollable div
                    overflowY: "auto",
                    marginTop: "5px",
                    padding: "10px",
                    backgroundColor: "#fff",
                    position: "fixed",
                    zIndex: "500",
                  }}
                >
                  {postCodeResults?.map((suggestion, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "5px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                      }}
                      onClick={() => handleSuggestionClick(suggestion)} // Handle click on suggestion
                    >
                      {suggestion.address}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Location
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.location}
                onChange={(e) => handleInputChange("location", e.target.value)}
              />
              {errors.location && (
                <small className="text-danger">{errors.location}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
  <label className="form-label">Qty</label>
  <input
    type="number"
    className="form-control"
    min={0}
    value={formData.quantity}
    onChange={(e) => handleInputChange("quantity", e.target.value)}
    onWheel={(e) => e.target.blur()}
  />
</div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Company <span className="text-danger">*</span>
              </label>
              <Select
                value={
                  formData.companyId
                    ? { value: formData.companyId, label: formData.company }
                    : null
                }
                options={companyOptions}
                onChange={(selectedOption) => {
                  const selectedCompany = findCompanyById(selectedOption?.value);
                  const companyName = selectedCompany?.companyName || "";
                  
                  getCompanyPeople(selectedOption?.value);
                  setFormData((prev) => ({
                    ...prev,
                    companyId: selectedOption?.value || "",
                    company: companyName,
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    companyId: "",
                    company: "",
                  }));
                }}
                formatOptionLabel={(option) => {
                  if (option.isChild) {
                    return (
                      <div style={{ paddingLeft: '20px' }}>
                        └─ {option.label.split(' - ')[1]}
                      </div>
                    );
                  }
                  return <strong>{option.label}</strong>;
                }}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? '#deebff' 
                      : state.data.isChild && state.isFocused ? '#f5f5f5'
                      : state.isFocused ? '#f0f0f0' 
                      : 'white',
                    color: state.data.isChild ? '#666' : '#333',
                    fontWeight: 'normal',
                    padding: state.data.isChild ? '8px 12px 8px 32px' : '8px 12px'
                  }),
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999
                  })
                }}
                filterOption={(option, inputValue) => {
                  const { data } = option;
                  
                  if (data.isParent) {
                    return true;
                  }
                  if (data.isChild) {
                    const parentCompany = companyOptions.find(opt => opt.value === data.parentId);
                    
                    if (parentCompany && parentCompany.label.toLowerCase().includes(inputValue.toLowerCase())) {
                      return true;
                    }
                    
                    return data.label.toLowerCase().includes(inputValue.toLowerCase());
                  }
                  
                  return true;
                }}
                isSearchable={true}
                className="basic-single"
                classNamePrefix="select"
              />
              {errors.company && (
                <small className="text-danger">{errors.company}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">Report To</label>
              <Select
                options={reportTo}
                value={
                  formData.jobReportTo
                    ? reportTo.find(
                        (option) => option.value === formData.jobReportTo
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  setFormData((prev) => ({
                    ...prev,
                    jobReportTo: selectedOption ? selectedOption.value : "",
                  }));
                }}
                placeholder="Report To"
              />
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">Invoice To</label>
              <Select
                options={invoiceTo}
                value={
                  formData.jobInvoiceTo
                    ? invoiceTo.find(
                        (option) => option.value === formData.jobInvoiceTo
                      )
                    : null
                }
                onChange={(selectedOption) => {
                  setFormData((prev) => ({
                    ...prev,
                    jobInvoiceTo: selectedOption ? selectedOption.value : "",
                  }));
                }}
              />
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Service <span className="text-danger">*</span>
              </label>
              <select
                className="form-control form-select"
                value={formData.service}
                onChange={(e) => handleInputChange("service", e.target.value)}
              >
                <option value=""></option>
                <option value="BOOKING">BOOKING</option>
              </select>
              {errors.service && (
                <small className="text-danger">{errors.service}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Controller <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                disabled
                value={formData.controller}
              />
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">Fee %</label>
              <input
                type="text"
                className="form-control"
                value={formData.feePercentage}
                onChange={(e) =>
                  handleInputChange("feePercentage", e.target.value)
                }
              />
            </div>

            {[
              { label: "Job Start Date", field: "jobStartDate" },
              { label: "Job End Date", field: "jobEndDate" },
            ].map(({ label, field }) => (
              <div className="col-xl-6 mb-3" key={field}>
                <label className="form-label">
                  {label} <span className="text-danger">*</span>
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  placeholder="dd/MM/yyyy"
                  className="form-control"
                  selected={formData[field]}
                  onChange={(date) => handleInputChange(field, date)}
                  showWeekNumbers={false}
                  locale="en-GB"
                  calendarStartDay={1}
                  weekStart={1}
                />
                {errors[field] && (
                  <small className="text-danger">{errors[field]}</small>
                )}
              </div>
            ))}

            {/* Status */}
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={formData.status}
                onChange={(e) => handleInputChange("status", e.target.value)}
              >
                <option value=""></option>
                <option value="LIVE">LIVE</option>
                <option value="ARCHIVED">ARCHIVED</option>
                <option value="CLOSED">CLOSED</option>
              </select>
              {errors.status && (
                <small className="text-danger">{errors.status}</small>
              )}
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">Account Number</label>
              <input
                type="text"
                className="form-control"
                value={formData.accountNumber}
                onChange={(e) =>
                  handleInputChange("accountNumber", e.target.value)
                }
              />
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">PO Number</label>
              <input
                type="text"
                className="form-control"
                value={formData.orderNumber}
                onChange={(e) =>
                  handleInputChange("orderNumber", e.target.value)
                }
              />
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">Reason</label>
              <select
                className="form-control"
                value={formData.reason}
                onChange={(e) => handleInputChange("reason", e.target.value)}
              >
                <option value=""></option>
                <option value="Standard Requirement">
                  Standard Requirement
                </option>
              </select>
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Hours of Work
              </label>
              <input
                type="text"
                className="form-control"
                value={formData.hoursOfWork}
                onChange={(e) =>
                  handleInputChange("hoursOfWork", e.target.value)
                }
              />
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Duties
              </label>
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  handleInputChange("duties", e.target.value)
                }
                value={formData.duties}
              />
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Experience
              </label>
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  handleInputChange("experience", e.target.value)
                }
                value={formData.experience}
              />
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Notes
              </label>
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  handleInputChange("notes", e.target.value)
                }
                value={formData.notes}
              />
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Health and Safety
              </label>
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  handleInputChange("healthSafety", e.target.value)
                }
                value={formData.healthSafety}
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Days of Work</label>
              <div className="d-flex flex-wrap">
                {days.map((day) => (
                  <div key={day} className="form-check me-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={day}
                      checked={formData.daysOfWork.includes(day)}
                      onChange={() => handleDaySelection(day)}
                    />
                    <label className="form-check-label" htmlFor={day}>
                      {day}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Pay Rates</label>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Pay Rate<br/>(&#xa3; in hours)</th>
                    <th>Charge Rate<br/>(&#xa3; in hours)</th>
                    <th>Type</th>
                    <th>Band</th>
                    <th>Description</th>
                    <th>Charge %</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {payRates.map((row, index) => (
                    <tr key={index}>
                      {[
                        "payRate",
                        "chargeRate",
                        "type",
                        "band",
                        "description",
                      ].map((field) => (
                        <td key={field}>
                          {field === "type" ? (
                            <select
                              style={{width: '90px'}}
                              className="form-control"
                              value={row[field]}
                              onChange={(e) =>
                                handleRateChange(index, field, e.target.value)
                              }
                            >
                              {payRateType?.map(itm => <option value={itm}>{itm}</option>)}
                            </select>
                          ) : (
                            <input
                              type={
                                field === "payRate" || field === "chargeRate"
                                  ? "number"
                                  : "text"
                              }
                              className="form-control"
                              value={row[field]}
                              onChange={(e) =>
                                handleRateChange(index, field, e.target.value)
                              }
                            />
                          )}
                        </td>
                      ))}
                      <td>
                        {row.payRate && row.chargeRate
                          ? (
                              ((row.chargeRate - row.payRate) /
                                row.chargeRate) *
                              100
                            ).toFixed(2) // Correct percentage increase calculation
                          : "--"}
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => handleRemoveRow(index)}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddRow}
              >
                Add Row
              </button>
            </div>
          </div>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <Link
            to={"#"}
            onClick={() => {
              resetForm();
              setAddJob(false);
            }}
            className="btn btn-danger ms-2"
          >
            Cancel
          </Link>
        </form>
      </div>
    </Offcanvas>
  );
});

export default AddRequirementJob;


